class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartContainer = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartContainer && typeof cartContainer.updateQuantity === 'function') {
        cartContainer.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    // Use scoped query for the line item status element
    this.lineItemStatusElement =
      this.querySelector('#shopping-cart-line-item-status') ||
      this.querySelector('#CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'cart-items') {
        this.onCartUpdate();
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) {
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value, 10);
    const index = event.target.dataset.index;
    let message = '';

    const min = parseInt(event.target.dataset.min, 10);
    const max = event.target.max ? parseInt(event.target.max, 10) : Infinity;
    const step = parseInt(event.target.step, 10);

    if (inputValue < min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', min);
    } else if (inputValue > max) {
      message = window.quickOrderListStrings.max_error.replace('[max]', max);
    } else if (inputValue % step !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
            const targetElement = this.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          });
            if (window.YR && typeof YR.updateAllDiscountLis === 'function') {
              YR.updateAllDiscountLis(); 
            }
      
          // CRITICAL: Also enforce on cart drawer updates
          if (window.YR && typeof YR.enforceIndexedBundles === 'function') {
            console.log('[YR] Cart drawer update - triggering enforcement');
            YR.enforceIndexedBundles().then(function(changed){
              console.log('[YR] Cart drawer enforcement result:', changed);
              if (changed) {
                console.log('[YR] Cart drawer: companions removed, triggering full cart update');
                // Trigger full cart update to refresh the entire drawer
                document.body.dispatchEvent(new Event('cart:updated'));
              }
            }).catch(function(error) {
              console.error('[YR] Error enforcing indexed bundles in cart drawer:', error);
            });
          }
        })
        .catch((e) => console.error(e));
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
          }
        })
        .catch((e) => console.error(e));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_change_url, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          this.querySelector(`#Quantity-${line}`) ||
          this.querySelector(`#Drawer-quantity-${line}`);
        const items = this.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container) return;
          const elementToReplace =
            container.querySelector(section.selector) || container;
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
          message =
            typeof updatedValue === 'undefined'
              ? window.cartStrings.error
              : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          if (cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`));
          } else {
            lineItem.querySelector(`[name="${name}"]`).focus();
          }
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (this.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, this.querySelector('.cart-item__name'));
        }


        // CRITICAL: Enforce companion removal immediately after any cart change
        if (window.YR && typeof YR.enforceIndexedBundles === 'function') {
          console.log('[YR] Cart quantity update - triggering enforcement');
          YR.enforceIndexedBundles().then(function (changed) {
            console.log('[YR] Enforcement completed, companions removed:', changed);
            if (changed) {
              console.log('[YR] Companions were removed, triggering cart update');
              // Trigger cart update to refresh the entire drawer
              document.body.dispatchEvent(new Event('cart:updated'));
            }
          }).catch(function(error) {
            console.error('[YR] Error enforcing indexed bundles:', error);
          });
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors =
          this.querySelector('#cart-errors') ||
          this.querySelector('#CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      this.querySelector(`#Line-item-error-${line}`) ||
      this.querySelector(`#CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.textContent = message;
      }
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      this.querySelector('#cart-live-region-text') ||
      this.querySelector('#CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const el = parsedHTML.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems =
      this.querySelector('#main-cart-items') ||
      this.querySelector('#CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemSpinners = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const drawerItemSpinners = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    [...cartItemSpinners, ...drawerItemSpinners].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems =
      this.querySelector('#main-cart-items') ||
      this.querySelector('#CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemSpinners = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const drawerItemSpinners = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    cartItemSpinners.forEach((overlay) => overlay.classList.add('hidden'));
    drawerItemSpinners.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Listen for Shopify's AJAX cart update
  document.addEventListener("cart:updated", function () {
    updateCartDrawer();
  });

  function updateCartDrawer() {
    console.log('[Cart] Updating cart drawer content...');
    
    // Fetch the updated cart data first
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        console.log('[Cart] Updated cart data:', cart);
        console.log('[Cart] Cart item count:', cart.item_count);
        
        // SUPER CRITICAL: If cart is empty, immediately hide recommendations to prevent ANY flash
        if (cart.item_count === 0) {
          const preRecommendations = document.getElementById('cart-drawer-recommendations');
          if (preRecommendations) {
            console.log('[Cart] IMMEDIATE hide of You May Also Like before any processing');
            preRecommendations.style.display = 'none';
            preRecommendations.style.visibility = 'hidden';
          }
        }
        
        // Fetch the full cart drawer HTML
        const cartDrawerWrapper = document.querySelector(".cart-drawer");
        if (cartDrawerWrapper) {
          fetch("/cart")
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const newCartContent = doc.querySelector(".cart-drawer");
              
              if (newCartContent) {
                console.log('[Cart] Replacing cart drawer content');
                
                // CRITICAL: Hide You May Also Like BEFORE HTML replacement if cart is empty
                const isEmpty = cart.item_count === 0;
                console.log('[Cart] Cart is empty:', isEmpty);
                
                if (isEmpty) {
                  // Hide recommendations section BEFORE HTML replacement to prevent flash
                  const currentRecommendations = document.getElementById('cart-drawer-recommendations');
                  if (currentRecommendations) {
                    console.log('[Cart] Pre-hiding You May Also Like section before HTML replacement');
                    currentRecommendations.style.display = 'none';
                  }
                  
                  // ALSO hide it in the new content before replacement
                  const newRecommendations = newCartContent.querySelector('#cart-drawer-recommendations');
                  if (newRecommendations) {
                    console.log('[Cart] Pre-hiding You May Also Like in new HTML content');
                    newRecommendations.style.display = 'none';
                  }
                }
                
                cartDrawerWrapper.innerHTML = newCartContent.innerHTML;
                
                // Apply empty state classes to all relevant elements
                const cartDrawerElement = document.querySelector('cart-drawer');
                const cartDrawerItems = document.querySelector('cart-drawer-items');
                const cartFooter = document.getElementById('main-cart-footer');
                const cartItemsContainer = document.querySelector('cart-items');
                const checkoutButton = document.getElementById('CartDrawer-Checkout');
                
                if (isEmpty) {
                  console.log('[Cart] Setting empty state on all elements');
                  if (cartDrawerElement) cartDrawerElement.classList.add('is-empty');
                  if (cartDrawerItems) cartDrawerItems.classList.add('is-empty');
                  if (cartFooter) cartFooter.classList.add('is-empty');
                  if (cartItemsContainer) cartItemsContainer.classList.add('is-empty');
                  if (checkoutButton) checkoutButton.disabled = true;
                } else {
                  console.log('[Cart] Removing empty state from all elements');
                  if (cartDrawerElement) cartDrawerElement.classList.remove('is-empty');
                  if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');
                  if (cartFooter) cartFooter.classList.remove('is-empty');
                  if (cartItemsContainer) cartItemsContainer.classList.remove('is-empty');
                  if (checkoutButton) checkoutButton.disabled = false;
                }
                
                // Reload cart carousel if function exists
                if (typeof window.reloadCartCarousel === 'function') {
                  window.reloadCartCarousel();
                }
                
                // Update YR discount list if available
                if (window.YR && typeof YR.updateAllDiscountLis === 'function') {
                  console.log('[Cart] Updating YR discount list');
                  YR.updateAllDiscountLis(cart);
                }
                
                // Update You May Also Like recommendations if available
                if (typeof window.loadRecommendationsFromCart === 'function') {
                  console.log('[Cart] Updating You May Also Like recommendations');
                  // Pass cart data to avoid extra fetch and speed up empty state detection
                  window.loadRecommendationsFromCart(cart);
                } else if (isEmpty) {
                  // Fallback: ensure recommendations are hidden even if function not available
                  const fallbackRecommendations = document.getElementById('cart-drawer-recommendations');
                  if (fallbackRecommendations) {
                    console.log('[Cart] Fallback hiding You May Also Like section');
                    fallbackRecommendations.style.display = 'none';
                  }
                }
                
                console.log('[Cart] Cart drawer update complete');
              } else {
                console.warn('[Cart] Could not find .cart-drawer in response');
              }
            })
            .catch(error => console.error('[Cart] Error fetching cart HTML:', error));
        } else {
          console.warn('[Cart] Cart drawer wrapper not found');
        }
      })
      .catch(error => console.error('[Cart] Error fetching cart data:', error));
  }
});

